import axios from 'lib/axios';

const getCustomerProfile = async () => {
  const { data } = await axios.get(`/customer/me`);
  return data;
};


const updateCustomerProfile = async ({body}) => {
  const { data } = await axios.put(`/customer/me`,body);
  return data;
};

export { getCustomerProfile, updateCustomerProfile};
